import { CAMERA_FACING_INTERNAL } from '../../utils';
import { useBaseStore } from '../base';

export const switchCamera = () => {
  useBaseStore.setState(state => ({
    cameraFacing:
      state.cameraFacing === CAMERA_FACING_INTERNAL.USER
        ? CAMERA_FACING_INTERNAL.ENVIRONMENT
        : CAMERA_FACING_INTERNAL.USER,
  }));
};
